import React from 'react'
import Button from '../../../../UI/Button'
import ReactStars from "react-rating-stars-component";
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useGiveRatingMutation } from '../../../../services/coachApi';
import { ToastContainer, toast } from 'react-toastify'
import Backdrop from '../../../../UI/Backdrop';

const Feedback = ({ setFeedback, setErrorBooking,closeModal,feedbackcoachId ,feedbackBookId}) => {

    const [livupRating, setLivupRating] = useState(1);
    const [coachRating, setCoachRating] = useState(1);
    const [inputValue, setInputValue] = useState("");
// console.log(feedbackcoachId);

    const ratingChanged = (newRating) => {
        setLivupRating(newRating);
    };
    const newRatingChanged = (newRating) => {
        setCoachRating(newRating);
    };

    const bookingId = useSelector(state => state.bookingReducer.bookingId);
    const coachId = useSelector(state => state.bookingReducer.coachId);
    // console.log(coachId,bookingId);
    
const coachname=localStorage.getItem('coach_name')
    //eslint-disable-next-line
    const [giveRating, { isLoading, isSuccess }] = useGiveRatingMutation();

    const giveRatingHandler = async () => {
        const formData = new FormData();

        formData.append('coach_id', feedbackcoachId);
        formData.append('rating', coachRating);
        formData.append('booking_id', feedbackBookId);
        formData.append('rating_type', 'therapist');
        formData.append('rating_exp_livup', livupRating);
        formData.append('feedback', inputValue);

        try {
            const response = await giveRating(formData);
            const data = response.data
           
            if(data.code === 'Success'){
                toast.success(`Rating Submitted Successfully!`)
                setTimeout(()=>{
                    closeModal();
                    
                }, 2000)
            }
        } catch (error) {
            // console.log(error);
        }
    }
     
    return (
        <>
            <ToastContainer hideProgressBar />
             {/* <Backdrop onClick={() => { setFeedback(false); setErrorBooking(false); }} /> */}
            <div className="fixed z-[999] top-0 flex flex-col justify-between h-max bottom-0 left-0 right-0 m-auto w-[50vw] bg-white rounded-[30px] overflow-hidden">
                <header className='bg-heavy h-10 flex justify-center items-center text-center text-black text-md font-bold'>Feedback</header>

                <div className="w-full p-8 text-left">
                    <span className="text-gray-500">Rate your Experience with Hapsmiths</span>
                    <ReactStars
                        count={5}
                        value={livupRating}
                        onChange={ratingChanged}
                        size={24}
                        activeColor="#f76411"
                    />
                    <br />
                    <span className="text-gray-500">Rate your Experience with the coach {coachname} </span>
                    <ReactStars
                        count={5}
                        value={coachRating}
                        onChange={newRatingChanged}
                        size={24}
                        activeColor="#f76411"
                    />
                    <br />
                    <span className="text-gray-500">Additional feedback</span> <small className="text-sm text-gray-400">(Optional)</small>
                    <div>
                        <input 
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        type="text" className="border-b-2 border-x-0 border-t-0 border-b-gray-500 focus:outline-none w-full my-2" />
                    </div>
                    <Button
                        onClick={giveRatingHandler}
                        className="bg-[#FFDBB0] text-[#F77F1F] h-[40px] rounded-[20px] w-[150px] mx-auto font-bold font-ubuntu">Submit</Button>
                </div>
            </div>
        </>
    )
}

export default Feedback